import { CustomInput, FileInput, ReactSelect } from "../kits/Inputs/Inputs";
import { useState, useEffect, useContext } from "react";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import "./SingleProduct.scss";
import CustomButton from "../kits/button/CustomButton";
import DatePicker, { Calendar } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import useAxios from "../../services/useAxios";
import { useNavigate } from "react-router-dom";
import { TrashIcon } from "../kits/Icons";
import ColorSchema from "../kits/Color";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip";
import ToastCustomize from "../kits/ToastCustomize";
import AuthenticationContext from "../../Authentication/AuthenticationContext";

export default function PrimaryProductFieldTab({
  // productType,
  setProductMainType,
  productMainType,
  productId,
  productConfig,
  materialConfig,
}) {
  let { userInfo } = useContext(AuthenticationContext);
  const [structureOption, setStructureOption] = useState([]);
  const [productType, setProductType] = useState([]);
  const priceType = [
    { value: 1, label: "درصد" },
    { value: 2, label: "مبلغ" },
  ];
  const [primaryProductData, setPrimaryProductData] = useState({
    title: "",
    description: "",
    file: "",
    file_id: 0,
    price: "",
    discount: "",
    main_type: "-1",
    end_time_discount: "",
    structure: "-1",
    benefitType: "-1",
    benefitAmount: 0,
  });
  const [primaryUpdate, setPrimaryUpdate] = useState(false);
  const primaryDataHandler = (name, value) => {
    setPrimaryProductData((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const navigate = useNavigate();
  const [errorTxt, setErrorTxt] = useState({
    title: "",
    type: "",
    benefitType: "",
    benefitAmount: "",
  });
  const validationFunc = () => {
    let validate = true;
    if (primaryProductData.title == "") {
      errorHandler("title", "لطفا نام محصول را وارد کنید!");
      validate = false;
    } else {
      errorHandler("title", "");
    }
    if (primaryProductData.main_type == "") {
      errorHandler("type", "لطفا نوع محصول را انتخاب کنید!");
      validate = false;
    } else {
      errorHandler("type", "");
    }
    return validate;
  };
  const errorHandler = (name, value) => {
    setErrorTxt((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const { loadingSubmit, execute: submit } = useAxios(
    "api/Insert_ProductServices"
  );
  const { loadingSubmitWhiteHouse, execute: submitWhiteHouse } = useAxios(
    "api/Insert_WhiteHouseItem"
  );
  const { loadingUpload, execute: uploadApi } = useAxios("api2/upload_img");
  const { loadingEdit, execute: edit } = useAxios("api/Update_ProductServices");
  const { loading, execute: FindProductService } = useAxios(
    "api/Find_ProductServices"
  );
  const { execute: getProductStructuresAPI } = useAxios(
    "api/get_product_structures"
  );
  const addWhiteHouse = (productId) => {
    let temp = {
      p_service_id: productId,
      inventory: 0,
      enter_count: 0,
      exit_count: 0,
      muid: userInfo?.id,
      upid: "",
      last_enter_count: 0,
      last_enter_tm: 0,
      last_exit_count: 0,
      last_exit_tm: 0,
      last_exit_uid: 0,
    };
    submitWhiteHouse(temp);
  };
  const submitData = async () => {
    console.log("file_id**", primaryProductData);
    let temp = 0;
    if (primaryProductData.file != "" && primaryProductData.file != undefined) {
      await uploadApi({ file: primaryProductData.file }).then((res) => {
        if (res.status == 1) {
          temp = res.file_info[0].id;
        }
        primaryDataHandler("file_id", temp);
      });
    } else {
      primaryDataHandler("file_id", primaryProductData.file_id);
      temp = primaryProductData.file_id;
    }

    if (productId == "create") {
      await submit({ ...primaryProductData, file_id: temp }).then((result) => {
        if (result.status == 1) {
          navigate(`/product/${result.result.id}`);

          ToastCustomize({
            mainText: "مشخصات اولیه با موفقیت ثبت شد!",
            duration: 2000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
          console.log(productMainType);
          if (productMainType == 1 || productMainType == 2)
            addWhiteHouse(result.result.id);
        } else {
          ToastCustomize({
            mainText: "متاسفانه مشکلی در ثبت پیش آمده است!",
            duration: 2000,
            toastType: "danger",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
        }
      });
    } else {
      edit({
        keyvalues:
          Object.keys(primaryProductData)
            .map((key) => `${key},${primaryProductData[key]}`)
            .join("@@") + `@@file_id,${temp}`,
        // `title,${primaryProductData.title}@@price,${primaryProductData.price}@@discount,${primaryProductData.discount}@@main_type,${primaryProductData.main_type}@@description,${primaryProductData.description}@@end_time_discount,${primaryProductData.end_time_discount}@@file_id,${temp}`,
        conditions: `id/=/${productId}`,
      }).then((result) => {
        if (result.status == 1) {
          setPrimaryUpdate((prev) => !prev);
          ToastCustomize({
            mainText: "مشخصات اولیه با موفقیت ویرایش شد!",
            duration: 2000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
        } else {
          ToastCustomize({
            mainText: "متاسفانه مشکلی در ویرایش پیش امده است.!",
            duration: 2000,
            toastType: "danger",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
        }
      });
    }
  };
  useEffect(() => {
    if (productId != "create")
      FindProductService({ conditions: `id/=/${productId}` }).then((result) => {
        setPrimaryProductData(...result);
        setProductMainType(result[0]?.main_type);
      });
  }, [productId, primaryUpdate]);

  useEffect(() => {
    getProductStructuresAPI().then((res) => {
      let temp = [];
      Object.keys(res.data).filter((key) => {
        if (key == "prepared_messages_categories") {
          setProductType(
            Object.keys(res.data["prepared_messages_categories"]).map(
              (key2) => ({
                label: res.data["prepared_messages_categories"][key2],
                value: key2,
              })
            )
          );
        } else temp.push({ value: key, label: res.data[key] });
      });
      setStructureOption(temp);
    });
  }, []);
  // useEffect(() => {
  //   let temp = [];
  //   if (productMainType == 1) temp = productConfig;
  //   else if (productMainType == 2) temp = materialConfig;
  //   setStructureOption(temp);
  //   console.log("****", temp, productMainType);
  // }, [productMainType]);

  console.log(primaryProductData);
  return (
    <div className="m-2 primary-product-field">
      <div className="w-30-input px-1 my-2">
        {" "}
        <CustomInput
          label="عنوان"
          inputSize="lg"
          type="text"
          inputContainer="w-90-input"
          inputValue={primaryProductData.title}
          onChangeFunc={(e) => primaryDataHandler("title", e.target.value)}
          textErr={errorTxt.title}
        />
      </div>
      <div className="w-30-input px-1 my-2">
        {" "}
        <ReactSelect
          title="انتخاب نوع محصول"
          itemsList={productType}
          inputContainer=""
          inputSize="lg"
          inputValue={productType.filter(
            (p) => p.value == primaryProductData.main_type
          )}
          onChangeFunc={(e) => {
            primaryDataHandler("main_type", e.value);
            setProductMainType(e.value);
          }}
          textErr={errorTxt.type}
        />
      </div>
      {productMainType == 1 && (
        <div className="w-30-input px-1 my-2">
          {" "}
          <ReactSelect
            title="انتخاب ساختار محصول"
            itemsList={structureOption}
            inputContainer=""
            inputSize="lg"
            inputValue={structureOption.filter(
              (p) => p.value == primaryProductData.product_structure_id
            )}
            onChangeFunc={(e) => {
              primaryDataHandler("product_structure_id", e.value);
            }}
          />
        </div>
      )}
      <div className="w-30-input px-1 my-2">
        <FileInput
          id="add-new-file"
          label="انتخاب عکس"
          txt="عکس محصول ..."
          onChangeFunc={(e) => primaryDataHandler("file", e.target.files[0])}
        />
      </div>
      <div className=" w-30-input px-1 my-2">
        {" "}
        <CustomInput
          label="قیمت (تومان)"
          inputSize="lg"
          type="text"
          inputContainer="w-90-input"
          inputValue={addCommas(primaryProductData.price)}
          onChangeFunc={(e) =>
            primaryDataHandler("price", removeCommas(e.target.value))
          }
          // textErr={validationTxt.answers}
        />
      </div>
      <div className=" w-30-input px-1 my-2">
        <CustomInput
          label="مبلغ تخفیف (تومان) "
          inputSize="lg"
          type="text"
          inputContainer="w-90-input"
          inputValue={addCommas(primaryProductData.discount)}
          onChangeFunc={(e) =>
            primaryDataHandler("discount", removeCommas(e.target.value))
          }
          // textErr={validationTxt.answers}
        />
      </div>
      <div className=" w-30-input px-1 my-2">
        <div className="d-flex justify-content-between">
          <label style={{ marginBottom: "0.5rem" }}>محدودیت تخفیف</label>

          <CustomTooltip
            title="پاک کردن تخفیف"
            placement="top"
            color="danger_custom"
          >
            <div onClick={() => primaryDataHandler("end_time_discount", "")}>
              <TrashIcon
                containerIconClassName="cursor-pointer"
                color={`${ColorSchema.danger_custom}`}
                width={20}
                height={20}
              />{" "}
            </div>
          </CustomTooltip>
        </div>

        <DatePicker
          value={parseInt(primaryProductData.end_time_discount) * 1000}
          calendar={persian}
          locale={persian_fa}
          calendarPosition="bottom-right"
          onChange={(e) => primaryDataHandler("end_time_discount", e.unix)}
        />
      </div>
      {productMainType == 1 && (
        <div className=" w-30-input px-1 my-2">
          <ReactSelect
            title="نوع تاثیر میزان سود"
            itemsList={priceType}
            inputContainer=""
            inputSize="lg"
            inputValue={priceType.filter(
              (p) => p.value == primaryProductData.benefitType
            )}
            onChangeFunc={(e) => {
              primaryDataHandler("benefitType", e.value);
              primaryDataHandler("benefitAmount", 0);
            }}
            textErr={errorTxt.benefitType}
          />
        </div>
      )}
      {productMainType == 1 && (
        <div className=" w-30-input px-1 my-2">
          <CustomInput
            label="میزان سود روی هر عدد "
            inputSize="lg"
            type="text"
            inputContainer="w-90-input"
            inputValue={addCommas(primaryProductData.benefitAmount)}
            onChangeFunc={(e) => {
              if (!isNaN(removeCommas(e.target.value))) {
                if (primaryProductData.benefitType == -1) {
                  errorHandler(
                    "benefitType",
                    "لطفا ابتدا نوع تاثیر را انتخاب کنید."
                  );
                } else if (
                  primaryProductData.benefitType == 1 &&
                  parseInt(removeCommas(e.target.value)) > 100
                ) {
                  errorHandler(
                    "benefitAmount",
                    "عدد وارد شده نباید بیشتر از 100 باشد."
                  );
                } else
                  primaryDataHandler(
                    "benefitAmount",
                    removeCommas(e.target.value)
                  );
              } else errorHandler("benefitAmount", "عدد وارد کنید.");
            }}
            textErr={errorTxt.benefitAmount}
          />
        </div>
      )}
      <div className="px-1 my-2" style={{ width: "99.99%" }}>
        {" "}
        <CustomInput
          label="توضیحات"
          inputSize="lg"
          type="text"
          inputContainer="w-90-input"
          inputType="textarea"
          inputValue={primaryProductData.description}
          onChangeFunc={(e) =>
            primaryDataHandler("description", e.target.value)
          }
          // textErr={validationTxt.answers}
        />
      </div>

      <div className="d-flex justify-content-end w-100">
        <div
          onClick={() => {
            if (validationFunc()) submitData();
          }}
        >
          {productId == "create" ? (
            <CustomButton color={"success"} size="medium">
              ثبت
            </CustomButton>
          ) : (
            <CustomButton color={"primary"} size="medium">
              ویرایش
            </CustomButton>
          )}
        </div>
      </div>
    </div>
  );
}
